import React  from 'react';
import './App.css';
import './QuestionLog.css';
import ReactTooltip from 'react-tooltip';

import QuestionLogListToolbar from './QuestionLogListToolbar.js';

import { useNavigate } from "react-router-dom";

class QuestionLogList extends React.Component {

	constructor(props) {

		super(props);
		
		this.state = {
			questionLogListJsonObj: null,
			logCount: 0,
			count: 10,
		};

		this.serverGetQuestionLogList = this.serverGetQuestionLogList.bind(this);
		this.separateAnswerText = this.separateAnswerText.bind(this);
		this.handlePrev = this.handlePrev.bind(this);
		this.handleNext = this.handleNext.bind(this);
		this.handleSelectQuestion = this.handleSelectQuestion.bind(this);
		this.renderOneQuestion = this.renderOneQuestion.bind(this);
		this.renderAllQuestions = this.renderAllQuestions.bind(this);
		this.renderPrevNext = this.renderPrevNext.bind(this);
	}
	
	componentDidMount() {
		var questionLogListIndex = this.props.questionLogListIndex;
		this.serverGetQuestionLogList(questionLogListIndex);
	}
	
	async serverGetQuestionLogList(index) {

		this.setState({
			questionLogListJsonObj: null,
		});
		
		var modelID = this.props.modelID;
		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getquestionloglist?modelid=" + modelID;
		url = url + "&sortby=createdUnixTimeSec&sortasc=0";
		url = url + "&index=" + index + "&count=" + this.state.count;

		const res = await fetch(url);
		const questionLogListJsonObj = await res.json();
		var logCount = questionLogListJsonObj.length;
		
		this.setState({
			questionLogListJsonObj: questionLogListJsonObj,
			logCount: logCount,
		});
	}
	
	separateAnswerText(answerText) {
		
		var index = answerText.indexOf("[DONE]");
		
		var answerText1; 
		var answerText2;
		
		if (index === -1) {
			answerText1 = answerText;
			answerText2 = "";
		} else {
			answerText1 = answerText.substring(0, index-1);
			answerText2 = answerText.substring(index+6, answerText.length);
		}

		return [answerText1, answerText2];
	}
	
	handlePrev() {
		var questionLogListIndex = this.props.questionLogListIndex - 10;
		this.props.setQuestionLogListIndex(questionLogListIndex);
		this.serverGetQuestionLogList(questionLogListIndex);
	}

	handleNext() {
		var questionLogListIndex = this.props.questionLogListIndex + 10;
		this.props.setQuestionLogListIndex(questionLogListIndex);
		this.serverGetQuestionLogList(questionLogListIndex);
	}
	
	handleSelectQuestion(questionLogID) {
		this.props.setSelectedQuestionLogID(questionLogID);
		const navigate = this.props.navigate;
  		navigate("/questionlog/view");
	}

	renderOneQuestion(itemObj) {

		var questionLogID = itemObj.questionLogID;
		var createdUnixTimeSec = itemObj.createdUnixTimeSec;
		var questionText = itemObj.questionText;
		var answerText = itemObj.answerText;
		var inputWordCount = itemObj.inputWordCount;
		var outputWordCount = itemObj.outputWordCount;
		var channel = itemObj.channel;
		
		var createdString = this.props.getDateTimeStringFromUnixTimeSec(createdUnixTimeSec);
		var tokenString = inputWordCount + "/" + outputWordCount;
		
		var answerText1 = "";
		var answerText2 = "";
		
		[answerText1, answerText2] = this.separateAnswerText(answerText);
		
		if (answerText2 === "") {} // da ne zuga warning

		var dataTip = answerText1;
		
		return (
			<tr data-tip={dataTip} key={questionLogID} className="QuestionLogListQuestionItemContainer" onClick={() => this.handleSelectQuestion(questionLogID)}> 
				<td className="QuestionLogListCreatedItem">{createdString}</td>
				<td className="QuestionLogListQuestionTextItem">{questionText}</td>
				<td className="QuestionLogListTokensItem">{tokenString}</td>
				<td className="QuestionLogListChannelItem">{channel}</td>
			</tr>
		);
	}

	renderAllQuestions() {

		var questionLogListJsonObj = this.state.questionLogListJsonObj;
		if (questionLogListJsonObj === null) {
			return;
		}

		var length = questionLogListJsonObj.length;
		if (length === 0) {
			return (
				<div className="QuestionLogListQuestionText">
					No questions found.
				</div>
			);
		}
		
		var i;
		var itemObj;
		var jsxCode;
		var jsxArray = [];
		
		for(i=0; i<length; i++) {
			itemObj = questionLogListJsonObj[i];
			jsxCode = this.renderOneQuestion(itemObj);
			jsxArray.push(jsxCode);
		}
		
		return (
			<table className="ListContainer2">
				<tbody>
					<tr>
						<td className="QuestionLogListCreatedHeader">Date/time</td>
						<td className="QuestionLogListQuestionTextHeader">Question</td>
						<td className="QuestionLogListTokensHeader">Words</td>
						<td className="QuestionLogListChannelHeader">Channel</td>
					</tr>
					{jsxArray}
				</tbody>
			</table>
		);
	}

	renderPrevNext() {
		
		var questionLogListJsonObj = this.state.questionLogListJsonObj;
		if (questionLogListJsonObj === null) {
			return;
		}

		var prevYN = false;
		var nextYN = false;
		
		var questionLogListIndex = this.props.questionLogListIndex;
		
		if (questionLogListIndex > 0) {
			prevYN = true;
		}
		
		if (questionLogListJsonObj.length === this.state.count) {
			nextYN = true;
		}
		
		return (
			<div className="ListContainer3">
				{prevYN && (<div 
					className="ListPrevNextLink"
					onClick={() => this.handlePrev()}
				>
					&lt;&lt; Previous
				</div>)}
				{!prevYN && (<div 
					className="ListPrevNextLinkDisabled"
				>
					&lt;&lt; Previous
				</div>)}
				<div className="ListPrevNextLinkDisabled">|</div>
				{nextYN && (<div 
					className="ListPrevNextLink"
					onClick={() => this.handleNext()}
				>
					Next &gt;&gt;
				</div>)}
				{!nextYN && (<div 
					className="ListPrevNextLinkDisabled"
				>
					Next &gt;&gt;
				</div>)}
			</div>
		);
	}
	
	render() {

		var questionLogListJsonObj = this.state.questionLogListJsonObj;
		if (questionLogListJsonObj === null) {
			return;
		}

		return (
			<div>
				<ReactTooltip
					type="info"
					delayShow={200}
					className="QuestionLogListTooltip"
				/>
				<QuestionLogListToolbar 
					modelName={this.props.modelName}
					chatAppUserType={this.props.chatAppUserType}
				/>
				<div className="QuestionLogListTopContainer">
					<div style={{height: "20px"}}></div>
					{this.renderAllQuestions()}
					<div style={{height: "40px"}}></div>
					{this.renderPrevNext()}
				</div>
			</div>
		);
	}
}

export default function QuestionLogListFunction(props) {
	const navigate = useNavigate();
	return <QuestionLogList {...props} navigate={navigate} />;
}

